var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "row notification-container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c(
                "router-link",
                {
                  staticClass: "sub-heading",
                  attrs: { to: "/layout/launchpad/systemnotificationslist" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.triggerEditEvent.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-angle-left" }),
                  _vm._v("System Notifications "),
                ]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "row mt-25" }, [
          _c("div", { staticClass: "col-xs-12 col-lg-11" }, [
            _c(
              "div",
              {
                staticClass:
                  "toggle_switch col-xs-12 col-sm-6 col-md-5 col-lg-4",
              },
              [
                _c(
                  "p",
                  [
                    _vm._v(" Maintenance Notification "),
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "bottom-start", trigger: "hover" },
                        on: {
                          show: function ($event) {
                            _vm.infoActive = true
                          },
                          hide: function ($event) {
                            _vm.infoActive = false
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "preference_popover_txt" }, [
                          _c("div", [
                            _vm._v(
                              "ON - The notification will be published immediately"
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              "OFF - The notification will not be published"
                            ),
                          ]),
                        ]),
                        !_vm.infoActive
                          ? _c("img", {
                              staticClass: "info-img",
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_icon.svg",
                                alt: "info-icon",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                        _vm.infoActive
                          ? _c("img", {
                              staticClass: "info-img",
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_icon_active.svg",
                                alt: "infoactive-icon",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _c("label", { staticClass: "switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.notification.is_active,
                        expression: "notification.is_active",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.notification.is_active)
                        ? _vm._i(_vm.notification.is_active, null) > -1
                        : _vm.notification.is_active,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.notification.is_active,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.notification,
                                "is_active",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.notification,
                                "is_active",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.notification, "is_active", $$c)
                        }
                      },
                    },
                  }),
                  _c("span", { staticClass: "slider round" }),
                ]),
                _vm.notification.is_active
                  ? _c("span", { staticClass: "switch_label" }, [_vm._v("On")])
                  : _c("span", { staticClass: "switch_label switch_off" }, [
                      _vm._v("Off"),
                    ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-6 col-md-offset-1 col-md-5 col-lg-offset-2 col-lg-4",
              },
              [
                _c("div", { staticClass: "form-group" }, [
                  _vm._v("Notification Type"),
                ]),
                _c("multiselect", {
                  staticClass: "multiselect-single-dropdown",
                  class: !_vm.notification.banner_type_id ? "un-selected" : "",
                  attrs: {
                    placeholder: "Select Notification Type",
                    options: _vm.BannerTypes.map((type) => type.id),
                    "custom-label": (opt) =>
                      _vm.BannerTypes.find((x) => x.id == opt).type,
                    searchable: false,
                    "allow-empty": false,
                    showLabels: false,
                    editable: "false",
                  },
                  model: {
                    value: _vm.notification.banner_type_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.notification, "banner_type_id", $$v)
                    },
                    expression: "notification.banner_type_id",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 col-md-5 col-lg-4" },
              [
                _c("div", { staticClass: "form-group" }, [
                  _vm._v("Start Date And Time (CST)"),
                ]),
                _c("date-picker", {
                  attrs: {
                    type: "datetime",
                    lang: "en",
                    "value-type": "format",
                    format: _vm.CSTFormat,
                    placeholder: "Select Start Date And Time (CST)",
                    "disabled-date": _vm.notBeforeTodayAfterEndDate,
                    "disabled-time": _vm.notBeforeTimeAfterEndTime,
                    "default-value": _vm.defaultStartTime,
                    editable: false,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.selectedStartDate()
                    },
                  },
                  model: {
                    value: _vm.notification.start_date,
                    callback: function ($$v) {
                      _vm.$set(_vm.notification, "start_date", $$v)
                    },
                    expression: "notification.start_date",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-6 col-md-offset-1 col-md-5 col-lg-offset-2 col-lg-4",
              },
              [
                _c("div", { staticClass: "form-group" }, [
                  _vm._v("End Date And Time (CST)"),
                ]),
                _c("date-picker", {
                  attrs: {
                    type: "datetime",
                    editable: false,
                    lang: "en",
                    "value-type": "format",
                    format: _vm.CSTFormat,
                    disabled: _vm.disableEndDate,
                    "disabled-date": _vm.notBeforeStartDate,
                    "disabled-time": _vm.notBeforeStartTime,
                    "default-value": _vm.defaultEndTime,
                    placeholder: "Select End Date And Time (CST)",
                  },
                  model: {
                    value: _vm.notification.end_date,
                    callback: function ($$v) {
                      _vm.$set(_vm.notification, "end_date", $$v)
                    },
                    expression: "notification.end_date",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12" }, [
              _c("p", [_vm._v("Banner Color Picker")]),
              _c(
                "div",
                { staticClass: "col-xs-12 col-md-10 color-radio p-0" },
                _vm._l(_vm.ulColors, function (color, index) {
                  return _c("label", { key: color }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notification.color,
                          expression: "notification.color",
                        },
                      ],
                      staticClass: "checkbox-tools",
                      attrs: {
                        type: "radio",
                        name: "tools",
                        id: "tool" + index,
                      },
                      domProps: {
                        value: color,
                        checked: _vm._q(_vm.notification.color, color),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.notification, "color", color)
                        },
                      },
                    }),
                    _c("label", {
                      staticClass: "for-checkbox-tools",
                      style: { "background-color": color },
                      attrs: { for: "tool" + index },
                    }),
                  ])
                }),
                0
              ),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-11 col-lg-10 form-group mt-30 mb-30",
              },
              [
                _c("label", [_vm._v("Banner Header")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.notification.header,
                      expression: "notification.header",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Banner Header" },
                  domProps: { value: _vm.notification.header },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.notification, "header", $event.target.value)
                    },
                  },
                }),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-11 col-lg-10 form-group",
              },
              [
                _c("label", [_vm._v("Banner Message")]),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.notification.message,
                      expression: "notification.message",
                    },
                  ],
                  staticClass: "form-control text-box",
                  attrs: { type: "text", placeholder: "Banner Message" },
                  domProps: { value: _vm.notification.message },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.notification, "message", $event.target.value)
                    },
                  },
                }),
              ]
            ),
            !_vm.is_edit
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-5 col-lg-4" },
                  [
                    _c("p", [_vm._v("Upload Icon")]),
                    _c("input", {
                      ref: "file",
                      staticClass: "form-control",
                      attrs: { type: "file", id: "file" },
                      on: {
                        change: function ($event) {
                          return _vm.validateFile()
                        },
                      },
                    }),
                    _vm.errorTxt
                      ? _c("div", { staticClass: "error-alert" }, [
                          _vm._v(_vm._s(_vm.errorTxt)),
                        ])
                      : _vm._e(),
                  ]
                )
              : _c("div", { staticClass: "col-xs-12" }, [
                  _c("p", [_vm._v("Upload Icon")]),
                  _c("div", { staticClass: "col-xs-12 p-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 p-0 input-radio" },
                      [
                        _c(
                          "base-radio",
                          {
                            attrs: {
                              name: "fileSelect",
                              optionValue: "old",
                              label: "old",
                            },
                            model: {
                              value: _vm.fileSelect,
                              callback: function ($$v) {
                                _vm.fileSelect = $$v
                              },
                              expression: "fileSelect",
                            },
                          },
                          [_c("span", [_vm._v("Existing Icon")])]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-xs-12 p-0" }, [
                      _c("p", { staticClass: "file_name" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("unescape")(
                                _vm.notification.logo_location.split("/").pop()
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-xs-12 p-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 p-0 input-radio" },
                      [
                        _c(
                          "base-radio",
                          {
                            attrs: {
                              name: "fileSelect",
                              optionValue: "new",
                              label: "new",
                            },
                            model: {
                              value: _vm.fileSelect,
                              callback: function ($$v) {
                                _vm.fileSelect = $$v
                              },
                              expression: "fileSelect",
                            },
                          },
                          [_c("span", [_vm._v("New Icon")])]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-6 col-md-5 col-lg-4 p-0",
                      },
                      [
                        _c("input", {
                          ref: "file",
                          staticClass: "form-control",
                          attrs: {
                            type: "file",
                            id: "file",
                            disabled: _vm.fileSelect === "old",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.validateFile()
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm.errorTxt
                    ? _c("div", { staticClass: "error-alert" }, [
                        _vm._v(_vm._s(_vm.errorTxt)),
                      ])
                    : _vm._e(),
                ]),
          ]),
        ]),
        _vm.showPreview
          ? _c("div", { staticClass: "row mt-25 m-0" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("p", [_vm._v("Maintenance Banner")]),
                _c("div", { staticClass: "col-xs-12 preview-container" }, [
                  _c(
                    "div",
                    { staticClass: "preview-banner" },
                    [
                      _c("notification-banner", {
                        attrs: { notification: _vm.previewNotification },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "row button-margin" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-4 col-md-4 col-lg-3 mb-10",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-blue-button",
                    attrs: {
                      type: "button",
                      disabled: _vm.disablePreviewButton,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.preview()
                      },
                    },
                  },
                  [_vm._v(" Update Preview ")]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-4 col-md-4 col-lg-offset-5 col-lg-2 mb-10",
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-block emergo-white-button",
                    attrs: {
                      to: "/layout/launchpad/systemnotificationslist",
                      tag: "button",
                    },
                  },
                  [_vm._v("Cancel")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-4 col-md-4 col-lg-2 mb-10",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-green-button",
                    attrs: {
                      type: "button",
                      disabled: _vm.disableButton || _vm.loaderStatus,
                    },
                    on: { click: _vm.addOrEditNotification },
                  },
                  [_vm._v(" save ")]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }